import { render, staticRenderFns } from "./ValuationForm.vue?vue&type=template&id=53846efb&scoped=true&"
import script from "./ValuationForm.vue?vue&type=script&lang=js&"
export * from "./ValuationForm.vue?vue&type=script&lang=js&"
import style0 from "./ValuationForm.vue?vue&type=style&index=0&id=53846efb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53846efb",
  null
  
)

export default component.exports